import React from 'react';
import ComingSoon from '../components/ComingSoon/ComingSoon';

const Portfolio = () => {
  return (
    <>
      <title>Referenzen – Nexite IT</title>
      {/* Not indexable until real content replaces the placeholder */}
      <meta name="robots" content="noindex" />
      <ComingSoon />
    </>
  );
};

export default Portfolio;
